import { render, staticRenderFns } from "./stock.html?vue&type=template&id=6db8f522&scoped=true&external"
import script from "./stock.js?vue&type=script&lang=js&external"
export * from "./stock.js?vue&type=script&lang=js&external"
import style0 from "./stock.scss?vue&type=style&index=0&id=6db8f522&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db8f522",
  null
  
)

export default component.exports